import * as React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(timezone);

export default function BasicDatePicker({
    handleDatePicker,
    valueData,
    disable,
    min,
}) {
    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                disabled={disable || false}
                value={valueData ? dayjs(valueData) : null}
                minDate={min ? dayjs(min) : undefined}
                format="DD-MM-YYYY"   // 👈 THIS is the key line
                onChange={(newValue) => handleDatePicker(newValue)}
                slotProps={{
                    textField: {
                        size: 'small',
                        fullWidth: true,
                        sx: {
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '10px',
                            },
                            '& .MuiOutlinedInput-notchedOutline': {
                                borderRadius: '10px',
                            },
                            fontSize: '12px',
                        },
                    },
                }}
            />
        </LocalizationProvider>
    );
}
